
import { loadStaticData, loadLabelData } from '../../utils/loadStaticData';
import setBrowserData from '../../utils/setBrowserData';

export default function OnEnterLoadApplicationData(store) {
  return (nextState, replace, done) => {
    loadStaticData(store)
      .then(() => loadLabelData(store))
      .then(() => setBrowserData(store))
      .then(() => {
        done();
      })
      .catch(done)
    ;
  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadApplicationData.js